export class CaptionModel {

   id: number;
   text: string;
   datafield: string;

   constructor(id: number, text: string, datafield: string) {
      this.id = id;
      this.text = text;
      this.datafield = datafield;
   }

}
